/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { companyControllerCreateV1 } from '../fn/company/company-controller-create-v-1';
import { CompanyControllerCreateV1$Params } from '../fn/company/company-controller-create-v-1';
import { companyControllerDeleteV1 } from '../fn/company/company-controller-delete-v-1';
import { CompanyControllerDeleteV1$Params } from '../fn/company/company-controller-delete-v-1';
import { companyControllerFindAllV1 } from '../fn/company/company-controller-find-all-v-1';
import { CompanyControllerFindAllV1$Params } from '../fn/company/company-controller-find-all-v-1';
import { companyControllerFindByIdV1 } from '../fn/company/company-controller-find-by-id-v-1';
import { CompanyControllerFindByIdV1$Params } from '../fn/company/company-controller-find-by-id-v-1';
import { companyControllerSearchCursorV1 } from '../fn/company/company-controller-search-cursor-v-1';
import { CompanyControllerSearchCursorV1$Params } from '../fn/company/company-controller-search-cursor-v-1';
import { companyControllerSearchV1 } from '../fn/company/company-controller-search-v-1';
import { CompanyControllerSearchV1$Params } from '../fn/company/company-controller-search-v-1';
import { companyControllerToggleExposedV1 } from '../fn/company/company-controller-toggle-exposed-v-1';
import { CompanyControllerToggleExposedV1$Params } from '../fn/company/company-controller-toggle-exposed-v-1';
import { companyControllerUpdateV1 } from '../fn/company/company-controller-update-v-1';
import { CompanyControllerUpdateV1$Params } from '../fn/company/company-controller-update-v-1';
import { CompanyDto } from '../models/company-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `companyControllerSearchV1()` */
  static readonly CompanyControllerSearchV1Path = '/api/v1/company/search';

  /**
   * Company 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerSearchV1$Response(params?: CompanyControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<CompanyDto>;
}>> {
    return companyControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerSearchV1(params?: CompanyControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<CompanyDto>;
}> {
    return this.companyControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<CompanyDto>;
}>): OffsetPaginationDto & {
'items'?: Array<CompanyDto>;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerSearchCursorV1()` */
  static readonly CompanyControllerSearchCursorV1Path = '/api/v1/company/search/cursor';

  /**
   * Company 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerSearchCursorV1$Response(params?: CompanyControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<CompanyDto>;
}>> {
    return companyControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerSearchCursorV1(params?: CompanyControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<CompanyDto>;
}> {
    return this.companyControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<CompanyDto>;
}>): CursorPaginationDto & {
'items'?: Array<CompanyDto>;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerFindAllV1()` */
  static readonly CompanyControllerFindAllV1Path = '/api/v1/company';

  /**
   * 모든 Company 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFindAllV1$Response(params?: CompanyControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyDto>>> {
    return companyControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Company 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFindAllV1(params?: CompanyControllerFindAllV1$Params, context?: HttpContext): Observable<Array<CompanyDto>> {
    return this.companyControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CompanyDto>>): Array<CompanyDto> => r.body)
    );
  }

  /** Path part for operation `companyControllerCreateV1()` */
  static readonly CompanyControllerCreateV1Path = '/api/v1/company';

  /**
   * Company 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerCreateV1$Response(params: CompanyControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDto>> {
    return companyControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerCreateV1(params: CompanyControllerCreateV1$Params, context?: HttpContext): Observable<CompanyDto> {
    return this.companyControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDto>): CompanyDto => r.body)
    );
  }

  /** Path part for operation `companyControllerFindByIdV1()` */
  static readonly CompanyControllerFindByIdV1Path = '/api/v1/company/{id}';

  /**
   * Company id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFindByIdV1$Response(params: CompanyControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDto>> {
    return companyControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFindByIdV1(params: CompanyControllerFindByIdV1$Params, context?: HttpContext): Observable<CompanyDto> {
    return this.companyControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDto>): CompanyDto => r.body)
    );
  }

  /** Path part for operation `companyControllerDeleteV1()` */
  static readonly CompanyControllerDeleteV1Path = '/api/v1/company/{id}';

  /**
   * Company 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerDeleteV1$Response(params: CompanyControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return companyControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerDeleteV1(params: CompanyControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.companyControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `companyControllerUpdateV1()` */
  static readonly CompanyControllerUpdateV1Path = '/api/v1/company/{id}';

  /**
   * Company 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerUpdateV1$Response(params: CompanyControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDto>> {
    return companyControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerUpdateV1(params: CompanyControllerUpdateV1$Params, context?: HttpContext): Observable<CompanyDto> {
    return this.companyControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyDto>): CompanyDto => r.body)
    );
  }

  /** Path part for operation `companyControllerToggleExposedV1()` */
  static readonly CompanyControllerToggleExposedV1Path = '/api/v1/company/{id}/expose';

  /**
   * Company 노출/노출해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerToggleExposedV1$Response(params: CompanyControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return companyControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Company 노출/노출해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerToggleExposedV1(params: CompanyControllerToggleExposedV1$Params, context?: HttpContext): Observable<boolean> {
    return this.companyControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
